import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import ModelsView from '../views/ModelsView.vue'
import ContactUs from '../views/ContactUs.vue'
import NewsView from '../views/NewsView.vue'
import NewsList from '../views/NewsList.vue'
import CarDetails from '../views/CarDetails.vue'
import CarDetails2 from '../views/CarDetails2.vue'
import ParamDetails2 from '../views/ParamDetails2.vue'
import CarDetails3 from '../views/CarDetails3.vue'
import ParamDetails from '../views/ParamDetails.vue'
import AboutUs from '../views/AboutUs.vue'
import PaymentSuccess from '../views/PaymentSuccess.vue'
import PaymentFailure from '../views/PaymentFailure.vue'

// function getLocalePath(path, locale) {
//   return path + (locale ? '-' + locale : ''); // 根据是否提供locale来决定是否添加后缀
// }

// params: { lang: 'zh' },
const routes = [
  // { path: '/', redirect: '/home' },
  // { path: '/', redirect: '/survey/:lang', component: HomeView, params: { lang: 'zh' } },
  { path: '/', component: HomeView },
  // { path: '/models', component: ModelsView },
  { path: '/contact', component: ContactUs },
  { path: '/news', component: NewsView },
  { path: '/newsList', component: NewsList },
  { path: '/carDetails', component: CarDetails },
  { path: '/carDetails2', component: CarDetails2 },
  { path: '/carDetails3', component: CarDetails3 },
  { path: '/paramDetails', component: ParamDetails },
  { path: '/paramDetails2', component: ParamDetails2 },
  { path: '/about', component: AboutUs },
  { path: '/contact/succeed', component: PaymentSuccess },
  { path: '/contact/failure', component: PaymentFailure },
  // { path: '/survey/:lang', name: 'HomeView', component: HomeView },
  // { path: '/survey', component: HomeView, params: { lang: 'en' }, meta: { lang: 'en' } },
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})
export default router